// extracted by mini-css-extract-plugin
module.exports = {"item":"ProductItem_item__25PHY","price":"ProductItem_price__3fMoR","actions":"ProductItem_actions__3pPsF"};